import { useQuery, useMutation, } from "@tanstack/react-query";
export const createCertificationStepJudgesQueries = (requests, queryClient) => ({
    useListCertificationStepJudges: (params, options = {}) => useQuery({
        queryKey: ["certification-step-judges", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listCertificationStepJudges(params);
        },
        ...options,
    }),
    useFindCertificationStepJudge: (params, options = {}) => useQuery({
        queryKey: ["certification-step-judge", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findCertificationStepJudge(params);
        },
        ...options,
    }),
    useFinalizeCertificationAttempt: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.finalizeCertificationAttempt,
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-step-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map